import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/index';

export default function getRootModule() {
  return {
    id: 'MAPS_MODALS',
    reducerMap: {
      MAPS_MODALS: rootReducer,
    },
    sagas: [rootSagas],
  };
}
